import { render, staticRenderFns } from "./MyCaptcha.vue?vue&type=template&id=6e8885b4&scoped=true"
import script from "./MyCaptcha.vue?vue&type=script&lang=js"
export * from "./MyCaptcha.vue?vue&type=script&lang=js"
import style0 from "./MyCaptcha.vue?vue&type=style&index=0&id=6e8885b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8885b4",
  null
  
)

export default component.exports